import React from 'react'

const About = ({about}) => (
    <section id="one">
        <header className="major">
        </header>
        <p>{about}</p>
    </section>
)

export default About
